// make top bar sticky
const navbar = document.getElementById('jsTop');

if (navbar) {
	window.addEventListener('scroll', () => {  
		if (window.pageYOffset >= 100) {
		  navbar.classList.add('sticky');
		} else {
		  navbar.classList.remove('sticky');
		}
		
	  });
}